angular.module("vgresiduos").controller("createVehicleCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/fornecedores/${$stateParams.supplierCode}/veiculo`, [
				{ key: "supplierId", value: $stateParams.supplierId }
			]);
		};
	}
]);
